const DB_NAME = 'neogist'
const DB_VERSION = 1
const GIST_STORE = 'gists'
const METADATA_STORE = 'metadata'

export function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)

    request.onerror = () => reject(request.error)
    request.onsuccess = () => resolve(request.result)

    request.onupgradeneeded = (event) => {
      const db = event.target.result

      if (!db.objectStoreNames.contains(GIST_STORE)) {
        const gistStore = db.createObjectStore(GIST_STORE, { keyPath: 'gist_id' })
        gistStore.createIndex('gist_created_at', 'gist_created_at', { unique: false })
        gistStore.createIndex('gist_updated_at', 'gist_updated_at', { unique: false })
      }

      if (!db.objectStoreNames.contains(METADATA_STORE)) {
        db.createObjectStore(METADATA_STORE, { keyPath: 'key' })
      }
    }
  })
}

export async function getAllGists() {
  const db = await openDB()

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([GIST_STORE], 'readonly')
    const store = transaction.objectStore(GIST_STORE)
    const request = store.getAll()

    request.onsuccess = () => resolve(request.result || [])
    request.onerror = () => reject(request.error)
  })
}

export async function saveGists(gists) {
  const db = await openDB()

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([GIST_STORE], 'readwrite')
    const store = transaction.objectStore(GIST_STORE)

    transaction.oncomplete = () => resolve()
    transaction.onerror = () => reject(transaction.error)

    store.clear()

    gists.forEach(gist => {
      store.put(gist)
    })
  })
}

export async function getMetadata(key) {
  const db = await openDB()

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([METADATA_STORE], 'readonly')
    const store = transaction.objectStore(METADATA_STORE)
    const request = store.get(key)

    request.onsuccess = () => resolve(request.result?.value || null)
    request.onerror = () => reject(request.error)
  })
}

export async function setMetadata(key, value) {
  const db = await openDB()

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([METADATA_STORE], 'readwrite')
    const store = transaction.objectStore(METADATA_STORE)
    const request = store.put({ key, value })

    request.onsuccess = () => resolve()
    request.onerror = () => reject(request.error)
  })
}

export async function clearAllData() {
  const db = await openDB()

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([GIST_STORE, METADATA_STORE], 'readwrite')

    transaction.oncomplete = () => resolve()
    transaction.onerror = () => reject(transaction.error)

    transaction.objectStore(GIST_STORE).clear()
    transaction.objectStore(METADATA_STORE).clear()
  })
}
